import * as bootstrap from 'bootstrap';
import { TTBackboneView } from '@/views/TTBackboneView';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { IndexViewController} from '@/portal/recruitment/IndexController'; // For the reference in the html file PortalJobVacancyView.html loaded from this file.
import { PortalJobVacancyRowController } from '@/views/portal/hr/recruitment/PortalJobVacancyRowController';

export class PortalBaseViewController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {
			can_cache_controller: true, //if allow to cache current controller
			pager_data: null,
			// required_files: [],

			events: {
				'click .search-btn': 'onSearchClick',
				'change select[id="country"]': 'onCountryChange',
				// 'click .more': 'loadMore'
				// 'click .styled-select .glyphicon': 'onSelectClick',
				'keydown input[id="name"]': 'autoSearch',
				// 'change select[id="province"]': 'onSearchClick',
				'keydown input[id="city"]': 'autoSearch'
			}
		} );

		super( options );
	}

	initialize( options ) {
		window.bootstrap = bootstrap;
		super.initialize( options );

		this.preInit( options );

		// __non_webpack_require__( this.getRequiredFiles(), function() {
		this.company_api = TTAPI.APICompanyPortal;
		LocalCacheData.current_open_primary_controller = this;
		this.init();
		this.postInit( options );
		// } );
	}

	// getRequiredFiles() {
	// 	//override in child class
	// 	return this.required_files.concat( this._required_files );
	// }

	preInit() {
		//Override in child class.
		return;
	}

	init() {
		//Override in child class.
		return;
	}

	postInit() {
		//Override in child class.
		return;
	}

	render() {
		var $this = this;
		ProgressBar.showOverlay();
		this.initOptions( function() {
			$this.search();
		} );

		$( window ).off( 'scroll' ).on( 'scroll', Global.debounce( function() {
			if ( $this.isOnScreen( '.more.container' ) ) {
				$this.loadMore();
			}
		}, 200 ) );
	}

	isOnScreen( element_id ) {
		let element = $( element_id );

		if ( element.length === 0 || !element.is( ':visible' ) ) {
			return false;
		}

		let bounding = element[0].getBoundingClientRect();

		if ( bounding.top >= 0 && bounding.left >= 0 && bounding.right <= ( window.innerWidth || document.documentElement.clientWidth ) && bounding.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) ) {
			return true;
		} else {
			return false;
		}
	}

	autoSearch( e ) {
		if ( e.keyCode === 13 ) {
			this.onSearchClick();
		}
	}

	initOptions( callback ) {
		this.initCountryOptions( callback );
	}

	initCountryOptions( callback ) {
		var $this = this;
		this.company_api.getOptions( 'country', {
			onResult: function( result ) {
				var result = result.getResult();
				$this.$( '#country' ).append( $( '<option></option>' ).prop( 'value', '' ).attr( 'selected', 'selected' ).text( $.i18n._( 'All Countries' ) ) );
				$.each( result, function( value, label ) {
					$this.$( '#country' ).append( $( '<option></option>' ).prop( 'value', value ).text( $.i18n._( label ) ) );
				} );
				$this.$( '#country' ).selectpicker();
				$this.$( '#province' ).selectpicker();
				callback();
			}
		} );
	}

	onCountryChange() {
		this.eSetProvince( this.$( 'select[id="country"]' ).val() );
	}

	eSetProvince( val ) {
		var $this = this;
		$this.$( '#province' ).selectpicker( 'destroy' );
		if ( !val ) {
			$this.$( '#province' ).html( $( '<option></option>' ).prop( 'value', '' ).attr( 'selected', 'selected' ).text( $.i18n._( 'All Province/States' ) ) );
			$this.$( '#province' ).selectpicker();
			return;
		}
		this.company_api.getOptions( 'province', val, {
			onResult: function( result ) {
				result = result.getResult();
				if ( !result ) {
					result = [];
				}
				$this.$( '#province' ).html( $( '<option></option>' ).prop( 'value', '' ).attr( 'selected', 'selected' ).text( $.i18n._( 'All Province/States' ) ) );
				$.each( result, function( value, label ) {
					$this.$( '#province' ).append( $( '<option></option>' ).prop( 'value', value ).text( $.i18n._( label ) ) );
				} );
				$this.$( '#province' ).selectpicker();
			}
		} );
	}

	loadMore() {
		this.onSearchClick( {
			page_action: 'next'
		} );
	}

	addSearchResultPanel() {
	}

	onSearchClick( options ) {
		var $this = this;
		var filter = {};
		this.addSearchResultPanel();
		// first load
		if ( typeof options == 'undefined' ) {
			options = {};
		}
		if ( typeof options.page_action == 'undefined' ) {
			this.$( '.search-result .content' ).empty();
		}
		this.vacancy_list_panel = this.$( '.search-result .content' );
		this.more_btn = this.$( '.search-result .more' );
		this.more_btn.unbind( 'click' ).bind( 'click', function() {
			$this.loadMore();
		} );
		filter.filter_data = {};
		filter.filter_sort = {};
		filter.filter_items_per_page = 0; // Default to 0 to load user preference defined
		// if ( this.$('#job_title_id').val() && parseInt( this.$('#job_title_id').val() ) > 0  ) {
		// 	filter.filter_data['title_id'] = this.$('#job_title_id').val();
		// }
		if ( this.$( '#name' ).val() && this.$( '#name' ).val() != '' ) {
			filter.filter_data['name'] = this.$( '#name' ).val();
		}
		if ( this.$( '#country' ).val() && this.$( '#country' ).val() != '' ) {
			filter.filter_data['country'] = this.$( '#country' ).val();
		}
		if ( this.$( '#province' ).val() && this.$( '#province' ).val() != '' ) {
			filter.filter_data['province'] = this.$( '#province' ).val();
		}
		if ( this.$( '#city' ).val() && this.$( '#city' ).val() != '' ) {
			filter.filter_data['city'] = this.$( '#city' ).val();
		}
		if ( this.pager_data ) {
			if ( options.page_action === 'next' ) {
				filter.filter_page = this.pager_data.next_page;
			} else {
				filter.filter_page = 1;
			}
		} else {
			filter.filter_page = 1;
		}

		//If branch_id is specified on the URL, pass that into the filter here as well.
		if ( LocalCacheData.getAllURLArgs() && LocalCacheData.getAllURLArgs().hasOwnProperty( 'branch_id' ) ) {
			filter.filter_data['branch_id'] = LocalCacheData.getAllURLArgs().branch_id;
		}

		this.api['get' + this.api.key_name]( filter, false, { // paging or none
			onResult: function( result ) {
				$this.pager_data = result.getPagerData();
				var result_data = result.getResult();
				var no_result_panel = $this.vacancy_list_panel.find( '.vacancy-list-no-result' );
				if ( no_result_panel[0] || ( $this.pager_data && $this.pager_data.is_first_page ) ) {
					$this.vacancy_list_panel.empty();
				}
				if ( !Global.isArray( result_data ) ) {
					var no_result_span = $( '<div class="vacancy-list-no-result">' + $.i18n._( 'No Results Found' ) + '</div>' );
					$this.vacancy_list_panel.html( no_result_span );
				} else {
					for ( var i = 0; i < result_data.length; i++ ) {
						var row = result_data[i];
						var vacancy_model = new Backbone.Model( row );
						var vacancy_row = new PortalJobVacancyRowController( { model: vacancy_model } );
						$this.vacancy_list_panel.append( vacancy_row.el );
					}
				}

				if ( !$this.pager_data || $this.pager_data.is_last_page || result_data === true ) {
					$this.more_btn.hide();
				} else {
					$this.more_btn.show();
				}
				if ( typeof options.callback != 'undefined' ) {
					options.callback();
				}
			},
			onError: function () {
				//Issue #3083 - This search call is being aborted which will result in a blank page if the user quickly goes to "My Profile" and logs out immediately.
				//In addition, the async calls are being aborted, so we cannot call search again as all future calls are also aborted.
				//This is a rare enough scenario that we have opted to do a reload in this specific case.
				window.location.reload();
			}
		} );
	}

	onSelectClick( e ) {
		var elem = $( e.currentTarget ).parent().find( 'select' );
		if ( document.createEvent ) {
			var e = document.createEvent( 'MouseEvents' );
			e.initMouseEvent( 'mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null );
			elem[0].dispatchEvent( e );
		} else if ( element.fireEvent ) {
			elem[0].fireEvent( 'onmousedown' );
		}
	}
}

PortalBaseViewController.loadView = function( view_id ) {
	Global.loadViewSource( view_id, view_id + 'View.html', function( result ) {
		var template = _.template( result )();
		window.IndexViewController = IndexViewController; // // For the reference in the html file PortalJobVacancyView.html loaded from this file.
		Global.contentContainer().html( template );

		LocalCacheData.current_open_view_id = view_id;

		$( 'div.tooltip' ).remove(); //Issue #2676 - Removing tooltips on page load to prevent validation errors from lingering on screen.

		Global.trackView( view_id, LocalCacheData.current_doing_context_action );
	} );

};
